import { getPathName } from "../../utils/utils";
const RecipeIcon = (props: any) => {
  const pathName = getPathName();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 30 30"
      {...props}
    >
      <path
        stroke={
          pathName == "/recipe-simulator"
            ? "var(--menuBarIconActive)"
            : "var(--menuBarIconDeactive)"
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="M6.241 22.514 24 22.5m-9-21a6.004 6.004 0 0 1 5.865 4.726A6 6 0 1 1 24 17.812V28.5H6V17.811A6.001 6.001 0 1 1 9.138 6.226 6 6 0 0 1 15 1.5Z"
      />
    </svg>
  );
};
export default RecipeIcon;
